// #region Global Imports
import styled from "styled-components";
// #endregion Global Imports

export const Container = styled.hr`
    border: 1px solid ${({ theme }) => theme.colors.lightGray};
    width: 100%;
`;
